import { render, staticRenderFns } from "./ReturnItemSummary.vue?vue&type=template&id=3d00607c&scoped=true&"
import script from "./ReturnItemSummary.vue?vue&type=script&lang=js&"
export * from "./ReturnItemSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReturnItemSummary.vue?vue&type=style&index=0&id=3d00607c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d00607c",
  null
  
)

export default component.exports